import okaoAxios from './axios'
import { infoLog, debugLog, errorLog } from '../utils/log-helper'

export interface RedeemRewardRequest {
  rewardCode: string
}

export interface PayInWalletRequest {
  rewardCode: string
}

export interface PayInWalletResponse {
  paymentLinkUrl: string
  amountCents: number
  pointsCost?: number | null
}

export interface RedeemRewardResponse {
  status: string
  rewardCode: string
  amountCents?: number
  // In-app claim link so the reward can be claimed inside the app even if the account email is
  // fake/undeliverable. May be absent if it couldn't be minted at send time — the app can then
  // regenerate it from walletEntryId via POST /wallet/payouts/{walletEntryId}/regenerate-link.
  claimUrl?: string
  walletEntryId?: string
}

export async function redeemReward(
  rewardCode: string,
): Promise<RedeemRewardResponse> {
  const start = performance.now()
  infoLog('[API] redeemReward start', { url: '/wallet/redeem', method: 'POST', params: { rewardCode } })

  try {
    const body: RedeemRewardRequest = { rewardCode }
    const response = await okaoAxios.post<RedeemRewardResponse>('/wallet/redeem', body)
    const durationMs = Math.round(performance.now() - start)
    debugLog('[API] redeemReward success', { status: response.status, durationMs, rewardCode, hasClaimUrl: !!response.data?.claimUrl })
    return response.data
  } catch (error: any) {
    const durationMs = Math.round(performance.now() - start)
    errorLog('[API] redeemReward failed', { status: error.response?.status, durationMs, rewardCode, error })
    throw error
  }
}

export async function payInWallet(
  rewardCode: string,
): Promise<PayInWalletResponse> {
  const start = performance.now()
  infoLog('[API] payInWallet start', { url: '/wallet/pay-in', method: 'POST', params: { rewardCode } })
  
  try {
    const body: PayInWalletRequest = { rewardCode }
    const response = await okaoAxios.post<PayInWalletResponse>(
      '/wallet/pay-in',
      body,
    )
    const durationMs = Math.round(performance.now() - start)
    debugLog('[API] payInWallet success', { status: response.status, durationMs, rewardCode, amountCents: response.data.amountCents })
    return response.data
  } catch (error: any) {
    const durationMs = Math.round(performance.now() - start)
    errorLog('[API] payInWallet failed', { status: error.response?.status, durationMs, rewardCode, error })
    throw error
  }
}

